import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "Free 方案是否真的永久免費？",
    answer: "是。Free 方案沒有月費，毋須綁定信用卡，也沒有強制升級要求。",
    points: [
      "首次註冊可獲 US$20 永久額度，永久有效，可抵扣任意 AI 費用。",
      "每月可獲 US$5 月額度，同樣可抵扣任意 AI 費用。",
      "只有需要更多渠道、25 種語言、專業交付或團隊協作時，才需要考慮 Pro 或 Team。",
    ],
  },
  {
    question: "體驗額度如何計算？",
    answer: "Free 包含首次註冊的 US$20 永久額度，以及每月 US$5 月額度；兩者的使用範圍相同，均可抵扣任意 AI 費用。",
    points: [
      "US$20 永久額度約可處理 5,000 條訊息，或約 200 分鐘語音。",
      "訊息與語音是兩種可選用法，不需要同時使用，也不會重複扣除。",
      "實際用量會隨所選 AI 模型、對話長度、語音時長及執行的工作流而變動，後台會顯示餘額與使用記錄。",
    ],
  },
  {
    question: "語音與訊息會同時扣除額度嗎？",
    answer: "不會。語音與訊息是「或」的關係，系統只會按客人實際使用的渠道計算。",
    points: [
      "客人致電時，按實際語音通話及相關 AI 使用量扣除。",
      "客人透過網頁、電郵或訊息渠道聯絡時，按訊息及相關 AI 使用量扣除。",
      "同一份額度可以靈活用於不同渠道，毋須預先分配語音與訊息的比例。",
    ],
  },
  {
    question: "Free、Pro、Team 應該怎樣選？",
    answer: "可以按配置方式、接待規模及團隊協作需要選擇。三個方案的主要差別如下：",
    points: [
      "Free：適合個人或小型團隊 DIY，自行配置接待知識、預約規則及工作流。",
      "Pro：適合需要專業團隊對接交付的業務，包含更多渠道、25 種語言及自動跟進。",
      "Team：適合多人共同接待，提供共享額度、3 個團隊帳號、專業 PMS 對接及團隊通知。",
    ],
  },
  {
    question: "支援哪些語言？",
    answer: "Free 已支援香港業務最常用的廣東話、普通話及英語，並可按客人的語言自然回應。",
    points: [
      "可結合你的服務資料、常見問題及業務知識回答，不只提供固定模板回覆。",
      "同一段對話中，客人轉換語言時，接待流程仍可延續，不需要手動切換模式。",
      "Pro 支援 25 種語言，適合需要服務海外客戶或跨地區營運的企業。",
    ],
  },
  {
    question: "可以在哪些渠道接待客戶？",
    answer: "Free 可處理電郵、電話及網頁上的查詢與預約，讓基本接待流程先運作起來。",
    points: [
      "不同渠道可以共用同一套知識、預約規則和工作流程，減少重複設定。",
      "Pro 可加入 WhatsApp 等更多入口，方便客人使用平日最熟悉的渠道聯絡。",
      "接待結果可按流程同步到日曆或業務系統，讓後續工作有記錄可跟進。",
    ],
  },
  {
    question: "可以接入現有日曆、PMS 或預約系統嗎？",
    answer: "可以。ClawEase 可接入日曆、PMS、CRM 或預約系統，按你現有的工作方式讀取及更新資料。",
    points: [
      "常見流程包括查閱可用時段、建立或修改預約、記錄客戶需要，以及同步處理結果。",
      "系統會先確認可用的連接方式、權限範圍及需要寫入的資料，避免改動不應處理的內容。",
      "簡單流程可自行配置；涉及專業 PMS、內部系統或多部門協作時，可由交付團隊評估並完成對接。",
    ],
  },
  {
    question: "遇到 AI 無法處理的問題怎麼辦？",
    answer: "可以把不能自動處理的情況轉交人工，客人毋須重新說明之前的內容。",
    points: [
      "你可以設定 AI 的執行規則、授權範圍，以及必須先取得確認的關鍵步驟。",
      "退款、特殊報價、投訴或其他超出權限的要求，可直接觸發人工接手流程。",
      "轉接時會保留已有對話與客人需要，人工同事可以自然延續處理。",
    ],
  },
  {
    question: "客戶資料與執行記錄如何保護？",
    answer: "ClawEase 從資料傳輸、憑證儲存到工作流執行記錄，提供多層安全保護。",
    points: [
      "客戶資料與系統之間的連線使用 HTTPS 加密傳輸。",
      "電話、電郵、日曆等連接憑證採用 AES-256-GCM 加密儲存，並按帳戶及權限隔離。",
      "工作流會保留執行結果與必要記錄，方便授權人員查閱、核對及追溯。",
    ],
  },
];

export function HomeFaqHK() {
  return (
    <section id="faq" className="ce-hk-section ce-hk-faq">
      <div className="ce-hk-section-inner">
        <div className="ce-hk-faq-heading">
          <h2>開始前，你可能想知道。</h2>
          <p className="ce-hk-section-lede">關於方案、額度、語言、渠道、系統對接與資料安全的常見答案。</p>
        </div>
        <div className="ce-hk-faq-list">
          {faqs.map((item) => (
            <details className="ce-hk-faq-item" key={item.question}>
              <summary>
                <span>{item.question}</span>
                <ChevronDown aria-hidden="true" size={18} strokeWidth={2.2} />
              </summary>
              <div className="ce-hk-faq-answer">
                <p>{item.answer}</p>
                <ul>
                  {item.points.map((point) => <li key={point}>{point}</li>)}
                </ul>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
